// Pfad des Knoten-Lexikons in der App (/tipps/knoten[/<slug>]). Dort springt ein 401 nicht zur Anmeldung um:
// das Lexikon braucht kein Konto (src/shared/area.js).
export const LEXICON_PATH = /(?:^|\/)tipps\/knoten(?:\/|$)/;
